<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-12">
                    <h2>{{ title }}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header p-2">
                            <ul class="nav nav-pills">
                                <li class="nav-item"><a class="nav-link active show" href="#general"
                                                        data-toggle="tab">{{ $t('general') }}</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="#festivals"
                                                        data-toggle="tab">{{ $t('festivals') }}</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="#materials"
                                                        data-toggle="tab">{{ $t('film_materials') }}</a></li>
                                <li class="nav-item"><a class="nav-link" href="#film_screening"
                                                        data-toggle="tab">{{ $t('film_screening') }}</a></li>
                            </ul>
                        </div><!-- /.card-header -->
                        <div class="card-body">
                            <div class="tab-content">
                                <div class="tab-pane active show" id="general">
                                    <form class="form-horizontal">
                                        <div id="accordion">
                                            <div class="card card-default">
                                                <div class="card-header">
                                                    <a class="d-block w-100" data-toggle="collapse" href="#information"
                                                       aria-expanded="true">
                                                        {{ $t('information') }}
                                                    </a>
                                                </div>
                                                <div id="information" class="collapse show" data-parent="#accordion"
                                                     style="">
                                                    <div class="card-body">
                                                        <text-input :form="form"
                                                                    :label="$t('Title international') +' *'"
                                                                    name="title_international"/>
                                                        <text-input :form="form" :label="$t('Title original') +' *'"
                                                                    name="title_original"/>
                                                        <text-input :form="form" :label="$t('Director(s)') +' *'"
                                                                    name="director"/>
                                                        <text-input :form="form" :label="$t('year') +' *'" name="year"/>

                                                        <multi-select-input :label="$t('country_ies') +' *'"
                                                                            :form="form"
                                                                            name="countries"
                                                                            :options="$countries"/>

                                                        <text-input :type="'number'" :form="form"
                                                                    :label="$t('lenght') +' *'" name="lenght"
                                                                    :note="'Round up the duration if the last minute is longer than 20 seconds.'"/>

                                                        <multi-select-input :label="$t('genres') +' *'"
                                                                            :form="form"
                                                                            name="genres"
                                                                            :options="$genres"/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card card-default">
                                                <div class="card-header">
                                                    <a class="d-block w-100" data-toggle="collapse" href="#content"
                                                       aria-expanded="true">
                                                        {{ $t('content') }}
                                                    </a>
                                                </div>
                                                <div id="content" class="collapse show" data-parent="#accordion"
                                                     style="">
                                                    <div class="card-body">

                                                        <text-area-input :form="form"
                                                                         :label="$t('synopsis') +' *'"
                                                                         name="synopsis"
                                                                         :limitmax-count="300"/>

                                                        <multi-select-input :label="$t('themes_tags') +' *'"
                                                                            :form="form"
                                                                            name="tags"
                                                                            :options="$tags"
                                                                            :note="$t('themes_note')"
                                                                            :max="7"/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card card-default">
                                                <div class="card-header">
                                                    <a class="d-block w-100" data-toggle="collapse" href="#tech-spec"
                                                       aria-expanded="true">
                                                        {{ $t('technical_specifications') }}
                                                    </a>
                                                </div>
                                                <div id="tech-spec" class="collapse show" data-parent="#accordion"
                                                     style="">
                                                    <div class="card-body">
                                                        <multi-select-input :label="$t('language_s') +' *'"
                                                                            :form="form"
                                                                            name="languages"
                                                                            :options="$languages"/>

                                                        <select-input :label="$t('aspect_ratio') +' *'"
                                                                      :form="form"
                                                                      name="aspect_ratio"
                                                                      :options="$aspect_ratio"/>

                                                        <text-input :form="form" :label="$t('specify_which') +' *'"
                                                                    name="aspect_ratio_specify"
                                                                    v-show="form.aspect_ratio === 6"/>

                                                        <select-input :label="$t('colours') +' *'"
                                                                      :form="form"
                                                                      name="colors"
                                                                      :options="$colorization"/>

                                                        <multi-select-input :label="$t('audiences') +' *'"
                                                                            :form="form"
                                                                            name="audiences"
                                                                            :options="$audiences"/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card card-default">
                                                <div class="card-header">
                                                    <a class="d-block w-100" data-toggle="collapse" href="#cast-crew"
                                                       aria-expanded="true">
                                                        {{ $t('cast_crew') }}
                                                    </a>
                                                </div>
                                                <div id="cast-crew" class="collapse show" data-parent="#accordion"
                                                     style="">
                                                    <div class="card-body">
                                                        <text-input :form="form" :label="$t('cast')" name="cast"/>

                                                        <text-input :form="form" :label="$t('animation')"
                                                                    name="animation"/>

                                                        <text-input :form="form" :label="$t('script') +' *'"
                                                                    name="script"/>

                                                        <text-input :form="form" :label="$t('cinematographer')"
                                                                    name="cinematographer"/>

                                                        <text-input :form="form" :label="$t('editor')" name="editor"/>

                                                        <text-input :form="form" :label="$t('sound_design')"
                                                                    name="sound"/>

                                                        <text-input :form="form" :label="$t('music')" name="music"/>

                                                        <text-input :form="form" :label="$t('vfx')" name="vfx"/>

                                                        <text-input :form="form" :label="$t('set_design')"
                                                                    name="set_design"/>

                                                        <text-input :form="form" :label="$t('costume_design')"
                                                                    name="costume_design"/>

                                                        <text-input :form="form" :label="$t('art_director')"
                                                                    name="art_director"/>

                                                        <text-input :form="form" :label="$t('producer_s') +' *'"
                                                                    name="producers"/>

                                                        <text-input :form="form" :label="$t('executive_producers')"
                                                                    name="executive_producers"/>

                                                        <text-input :form="form"
                                                                    :label="$t('production_companyies') +' *'"
                                                                    name="productions"/>

                                                        <text-input :form="form" :label="$t('coproduction_companyies')"
                                                                    name="coproductions"/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card card-default">
                                                <div class="card-header">
                                                    <a class="d-block w-100" data-toggle="collapse" href="#director"
                                                       aria-expanded="true">
                                                        {{ $t('director') }}
                                                    </a>
                                                </div>
                                                <div id="director" class="collapse show" data-parent="#accordion"
                                                     style="">
                                                    <div class="card-body">
                                                        <text-area-input :form="form"
                                                                         :label="$t('biography')"
                                                                         name="director_biography"
                                                                         :limitmax-count="800"
                                                                         :note="$t('director_biography_note')"/>

                                                        <div class="row">
                                                            <div class="col-md-3">
                                                                <label class="col-sm-12 control-label">
                                                                    {{ $t('year') }}
                                                                </label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <label class="col-sm-12 control-label">
                                                                    {{ $t('title_international') }}
                                                                </label>
                                                            </div>
                                                            <div class="col-md-1">
                                                            </div>
                                                        </div>

                                                        <form v-show="form.director_filmography"
                                                              class="form-horizontal">
                                                            <div class="row"
                                                                 v-for="(filmography,index) in form.director_filmography">
                                                                <div class="col-md-3">
                                                                    <div class="form-group">
                                                                        <div class="col-sm-12">
                                                                            <input type="text"
                                                                                   v-model="form.director_filmography[index].year"
                                                                                   class="form-control"
                                                                                   :id="index+'year'"
                                                                                   :class="{ 'is-invalid': form.errors.has('director_filmography.'+index+'.year') }"
                                                                            >
                                                                            <has-error :form="form"
                                                                                       :field="'director_filmography.'+index+'.year'"/>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-8">
                                                                    <div class="form-group">
                                                                        <div class="col-sm-12">
                                                                            <input type="text"
                                                                                   v-model="form.director_filmography[index].title"
                                                                                   class="form-control"
                                                                                   :id="index+'title'"
                                                                                   :class="{ 'is-invalid': form.errors.has('director_filmography.'+index+'.title') }"
                                                                            >
                                                                            <has-error :form="form"
                                                                                       :field="'director_filmography.'+index+'.title'"/>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-1">
                                                                    <a href="#"
                                                                       @click.prevent="deleteFilmography(index)">
                                                                        <i class="fa fa-trash blue"></i>
                                                                    </a>
                                                                </div>

                                                            </div>
                                                        </form>

                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <button @click.prevent="newFilmography"
                                                                            class="btn btn-warning">{{ $t('new') }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div class="tab-pane" id="festivals">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="alert alert-info">
                                                Drag and drop to sort the list in chronological order, from the oldest
                                                to the most recent festival.
                                                Please make sure to only add festival selections that can be announced
                                                publicly.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <label class="col-sm-12 control-label">
                                                {{ $t('year') }}
                                            </label>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="col-sm-12 control-label">
                                                {{ $t('name') }}
                                            </label>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="col-sm-12 control-label">
                                                {{ $t('section') }}
                                            </label>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="col-sm-12 control-label">
                                                {{ $t('award') }}
                                            </label>
                                        </div>
                                        <div class="col-md-1">
                                        </div>
                                    </div>

                                    <form v-show="form.festivals" class="form-horizontal">
                                        <draggable v-model="form.festivals" group="festivals" @start="drag=true"
                                                   @end="drag=false">
                                            <div class="row" v-for="(festival,index) in form.festivals">
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="col-sm-12">
                                                            <input type="text"
                                                                   v-model="form.festivals[index].year"
                                                                   class="form-control"
                                                                   :id="index+'year'"
                                                                   :class="{ 'is-invalid': form.errors.has('festivals.'+index+'.year') }"
                                                            >
                                                            <has-error :form="form"
                                                                       :field="'festivals.'+index+'.year'"/>
                                                        </div>
                                                    </div>
                                                </div><!-- /.festivals year -->

                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <div class="col-sm-12">
                                                            <div class="form-group">
                                                                <div class="col-sm-12">
                                                                    <multiselect :id="index+'name'"
                                                                                 v-model="form.festivals[index].festival"
                                                                                 :options="$festivals"
                                                                                 :multiple="false"
                                                                                 :close-on-select="true"
                                                                                 :clear-on-select="false"
                                                                                 :preserve-search="true"
                                                                                 :placeholder="$t('multiselect_placeholder')"
                                                                                 :label="'name'"
                                                                                 :track-by="'id'"
                                                                                 :preselect-first="false">
                                                                    </multiselect>
                                                                </div>
                                                            </div>


                                                            <!--                                                            <select v-model="form.festivals[index].name"-->
                                                            <!--                                                                    class="form-control"-->
                                                            <!--                                                                    :id="index+'name'"-->
                                                            <!--                                                                    :class="{ 'is-invalid': form.errors.has('festivals.'+index+'.name') }"-->
                                                            <!--                                                            >-->
                                                            <!--                                                                <option v-for="option in $festivals" :value="option.id">-->
                                                            <!--                                                                    {{ option.name }}-->
                                                            <!--                                                                </option>-->
                                                            <!--                                                            </select>-->
                                                            <has-error :form="form"
                                                                       :field="'festivals.'+index+'.name'"></has-error>
                                                        </div>
                                                    </div>
                                                </div><!-- /.festivals name -->

                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <div class="col-sm-12">
                                                            <input type="text"
                                                                   v-model="form.festivals[index].section"
                                                                   class="form-control"
                                                                   :id="index+'section'"
                                                                   :class="{ 'is-invalid': form.errors.has('festivals.'+index+'.section') }"
                                                            >
                                                            <has-error :form="form"
                                                                       :field="'festivals.'+index+'.section'"/>
                                                        </div>
                                                    </div>
                                                </div><!-- /.festivals section -->

                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="col-sm-12">
                                                            <input type="text"
                                                                   v-model="form.festivals[index].award"
                                                                   class="form-control"
                                                                   :id="index+'award'"
                                                                   :class="{ 'is-invalid': form.errors.has('festivals.'+index+'.award') }"
                                                            >
                                                            <has-error :form="form"
                                                                       :field="'festivals.'+index+'.award'"/>
                                                        </div>
                                                    </div>
                                                </div><!-- /.festivals award -->

                                                <div class="col-md-1">
                                                    <a href="#" @click="deleteFestival(index)">
                                                        <i class="fa fa-trash blue"></i>
                                                    </a>
                                                </div>

                                            </div>
                                        </draggable>
                                    </form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <button @click.prevent="newFestival"
                                                        class="btn btn-warning">{{ $t('new') }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <span><i><small>{{ $t('festivals_note') }}</small></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane" id="materials" v-if="form.id">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="alert alert-info">
                                                Files are automatically saved once the upload is completed. No need to
                                                also press Save at the bottom of the page.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 pb-3">
                                            <VueFileAgent
                                                v-model="form.materials"
                                                :theme="'list'"
                                                :maxSize="'50GB'"
                                                :deletable="true"
                                                :uploadUrl="uploadUrl"
                                                :uploadHeaders="uploadHeaders"
                                                @delete="deleteMovieMaterial"
                                                @upload="onUploadFile"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane" id="film_screening" v-if="form.id">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="alert alert-info">
                                                Files are automatically saved once the upload is completed. No need to
                                                also press Save at the bottom of the page.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="alert alert-info">
                                                {{ $t('screener_note') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="!form.vimeoEmbed && !filmScreeningIsUploaded">
                                        <div class="col-sm-4 offset-4 pb-3">
                                            <VueFileAgent
                                                v-model="filmScreening"
                                                :multiple="false"
                                                :maxSize="'50GB'"
                                                :deletable="true"
                                                :compact="true"
                                                :uploadUrl="fileScreeningUploadUrl"
                                                :uploadHeaders="uploadHeaders"
                                                maxFiles="1"
                                                :accept="'video/*'"
                                                @upload="onUploadFilmScreening"
                                                :helpText="$t('screener_upload_note')"
                                                thumbnailSize="20"
                                            />
                                        </div>
                                    </div>
                                    <div class="row" v-else-if="filmScreeningIsUploaded">
                                        <div class="col-sm-12 pb-3 text-center">
                                            {{ $t('screening_file_being_processing') }}
                                        </div>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-sm-12 pb-3 text-center" v-html="form.vimeoEmbed">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-12 text-right">
                                    <button @click.prevent="save" type="submit"
                                            class="btn btn-success">{{ $t('save') }}
                                    </button>
                                </div>
                            </div>
                        </div><!-- /.card-body -->
                    </div>
                    <!-- /.nav-tabs-custom -->
                </div>
                <!-- end tabs -->
            </div>
        </div>
    </section>
</template>

<script>
import TextInput from "../../shared/components/TextInput";
import movies from "../services/api/movies";
import MultiSelectInput from "../shared/components/MultiSelectInput";
import VueTimepicker from 'vue2-timepicker'
import TextAreaInput from "../../shared/components/TextAreaInput";
import SelectInput from "../shared/components/SelectInput";
import {HasError} from "vform/src/components/bootstrap4";
import draggable from 'vuedraggable'
import Multiselect from "vue-multiselect";

let festivalRow = {
    year: null,
    name: null,
    section: null,
    award: null,
}

let filmographyRow = {
    year: null,
    title: null
}

export default {
    name: "Movie",
    components: {
        SelectInput,
        TextAreaInput,
        MultiSelectInput,
        TextInput,
        VueTimepicker,
        HasError,
        draggable,
        Multiselect
    },
    data() {
        return {
            title: this.$t('new_movie_title'),
            movieId: null,
            form: null,
            uploadHeaders: window.axios.defaults.headers.common,
            uploadUrl: null,
            fileScreeningUploadUrl: null,
            filmScreening: null,
            filmScreeningIsUploaded: false,
        }
    },
    methods: {
        async created() {
            this.form = new Form()
            this.movieId = this.$route.params.id
            if (this.movieId) {
                this.$Progress.start()
                let response = await movies.show(this.movieId)
                this.form = new Form(response.data.data)
                this.title = this.$t('edit_movie_title') + ': ' + this.form.title_international
                this.uploadUrl = window.baseUrl + '/movies/' + this.form.id + '/material'
                this.fileScreeningUploadUrl = window.baseUrl + '/movies/' + this.form.id + '/screening'
                this.$Progress.finish();
            }
        },
        async save() {
            this.$Progress.start()
            try {
                let response = null
                if (!this.movieId) {
                    response = await this.form.post(window.baseUrl + '/movies')
                    await this.$router.push('movie/' + response.data.id)
                } else {
                    response = await this.form.put(window.baseUrl + '/movies/' + this.movieId)
                }
                this.$Progress.finish();
                await Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
            } catch (e) {
                console.log(e)
                this.$Progress.fail();
                await Toast.fire({
                    icon: 'error',
                    title: 'Error: the form could not be saved. Required fields cannot be empty. Please check in every tab.'
                });
            }

        },
        newFestival() {
            if (!this.form.festivals) {
                this.form.update({festivals: []})
                this.$forceUpdate()
            }
            this.form.festivals.push({...festivalRow})
        },
        newFilmography() {
            if (!this.form.director_filmography) {
                this.form.update({director_filmography: []})
                this.$forceUpdate()
            }
            this.form.director_filmography.push({...filmographyRow})
        },
        deleteFestival(index) {
            this.form.festivals.splice(index, 1)
        },
        deleteFilmography(index) {
            this.form.director_filmography.splice(index, 1)
        },
        onUploadFile(response) {
            this.form.update({materials: response[0].data})
        },
        onUploadFilmScreening() {
            this.filmScreeningIsUploaded = true
        },
        async deleteMovieMaterial(fileRecord) {
            this.$Progress.start()
            try {
                let response = await movies.deleteMovieMaterial(this.form.id, fileRecord.id)
                this.$Progress.finish();
                await Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
            } catch (e) {
                console.log(e)
                this.$Progress.fail();
                await Toast.fire({
                    icon: 'error',
                    title: 'Error: the form could not be saved. Required fields cannot be empty.'
                });
            }

        }
    },
    created() {
        this.created()
    }
}
</script>

<style scoped>

</style>
